export class TermsAndConditionsMsg{
    public static SUCCESS_MESSAGE = 'Thankyou  for accepting the terms and condition for Shared Retail Subscription !';
    public static FAILURE_MESSAGE = 'Something went wrong while accepting the terms and condition for Shared Retail Subscription';
    public static ACCEPTED_MESSAGE = 'Seems like you have already accepted the terms and conditions for Shared Retail Subscription !';
    public static UNEXPECTED_MESSAGE = 'Some unexpected error occurred please reach out customer-care';
    public static EXPIRED_LINK_MESSAGE = 'Sorry the link you are trying to access is expired. If you have any questions please contact customer care  ';
    public static SUCCESS_CLASS = 'success';
    public static DANGER_CLASS = 'danger';
    public static CHECK_ICON = 'check';
    public static CLOSE_ICON = 'close';
    public static DISTRIBUTORID_OR_LanguageCode = 'distributorIdOrLanguageCode';    
    public static EXPIRED_LINK = 'Expired Link';    
}


// WEBPACK FOOTER //
// ./src/app/customerservice/constants/terms-and-conditions-messages.constants.ts